import { useEffect, useMemo, useState } from "react";
import { t } from "i18next";

import WPDropdown from "../../../packages/WPDropdown";
import WPInput, { WPRangedInput } from "../../../packages/WPInput";

export const ChemicalLibInputBox = ({ control, onControlChange, onBlur }) => {
  const [inputConfig, setInputConfig] = useState({});

  useEffect(() => {
    setInputConfig(control);
  }, [control]);

  const validateInput = (value, min, max) => {
    const isNumberInput = isRangedInput || control?.inputType === "number";
    const isEmptyValue = value?.trim?.() === "";
    const numberValue = Number(value);
    const hasNumericValue = !isEmptyValue && !Number.isNaN(numberValue);
    const hasTypeError = isNumberInput && (isEmptyValue || !hasNumericValue);

    const hasRangeError =
      isRangedInput &&
      hasNumericValue &&
      ((min !== undefined && numberValue < min) ||
        (max !== undefined && numberValue > max));

    const hasError =
      hasTypeError || hasRangeError || Boolean(control?.validate?.(value));
    return hasError;
  };

  const handleInputChange = ({ target }) => {
    const { value: newValue } = target;

    const min = control?.range?.min;
    const max = control?.range?.max;
    const hasError = validateInput(newValue, min, max);

    onControlChange({
      id: control.id,
      data: { value: newValue },
      hasError,
    });
  };

  const normalizedRange = useMemo(() => {
    if (!control?.range) return null;
    return { hard: { ...control.range } };
  }, [control?.range]);

  const isRangedInput = !!control?.range;

  const InputComponent = isRangedInput ? WPRangedInput : WPInput;

  const baseProps = {
    label: control.label,
    required: true,
    id: control.id,
    name: control.id,
    value: inputConfig.value,
    disabled: inputConfig.disabled,
    onChange: handleInputChange,
    requiredMsg: t("ValueStrings.requiredField"),
    suffix: inputConfig?.unit,
    roundOff: inputConfig?.roundOff,
  };

  const inputProps = isRangedInput
    ? { ...baseProps, ranges: normalizedRange }
    : { ...baseProps, type: inputConfig.inputType, validate: control.validate };

  return <InputComponent {...inputProps} />;
};

export const ChemicalLibDropdown = ({ control, onControlChange }) => {
  const value = useMemo(() => {
    const key = control?.labelKey || "name";
    return control?.value
      ? control.options.find((item) => item[key] === control.value)
      : "";
  }, [control?.value, control?.labelKey, control?.options]);

  if (!control) return null;

  const handleDropdownChange = (data) =>
    onControlChange({ id: control.id, data });
  const getOptionLabel = (option, id) =>
    id === "category"
      ? t(`chemicalCategories.${option.id}`)
      : id === "chemical"
        ? // ? categoryBasedChemicals(option.categoryId, option.symbol)
          `${option.symbol} (${option.categoryId})`
        : option[control.labelKey];

  return (
    <div>
      <WPDropdown
        label={control.label}
        id={control.id}
        value={value}
        disabled={control.disabled}
        options={control.options}
        onChange={handleDropdownChange}
        placeholder={control.placeholder}
        getOptionLabel={(option) => getOptionLabel(option, control.id)}
      />
    </div>
  );
};
